var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluesky({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.718C12 16.6051 12.0432 16.7324 12.1365 17.006C12.64 18.4905 14.6073 24.2823 19.1046 19.6519C21.4728 17.214 20.3766 14.7766 16.0659 14.0404C18.5314 14.461 21.3046 13.7656 22.065 11.038C22.2839 10.2534 22.6572 5.42018 22.6572 4.76749C22.6572 1.49774 19.7999 2.52544 18.0372 3.85328C15.5935 5.69381 12.9649 9.42557 12 11.4285C11.0351 9.42557 8.4065 5.69438 5.96283 3.85328C4.20006 2.52544 1.34277 1.49832 1.34277 4.76749C1.34277 5.42018 1.71549 10.2534 1.93497 11.038C2.69538 13.7656 5.46798 14.4615 7.93412 14.0404C3.62342 14.7766 2.52717 17.2146 4.89537 19.6519C9.39272 24.2823 11.36 18.4905 11.8635 17.0066C11.9568 16.7324 12 16.6051 12 16.718Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluesky);
export default __webpack_public_path__ + "static/media/bluesky.d548e8f26cc66516ae4ddf25e8f233a4.svg";
export { ForwardRef as ReactComponent };